import React, { Component } from "react"
import getErrorText from "../../../../library/constants/errorTypes"
import NotFound from "../../../../components/notFound/notFound"
import { uploadFiles } from "../../../../library/utils/uploadFiles"
import Button from "@material-ui/core/Button/Button"
import * as routes from "../../../../library/constants/routes"
import CameraAltOutlined from "@material-ui/icons/CameraAltOutlined"
import logoDefault from "../../../../assets/img/product.svg"
import { bindActionCreators } from "redux"
import SettingsOutlined from "@material-ui/icons/SettingsOutlined"
import { connect } from "react-redux"
import { withSnackbar } from "notistack"
import {
  clearCurrentKnowmix,
  getKnowmix,
  startKnowmix,
  updateKnowmix,
} from "../../../../library/store/actions/creators/knowmixCreators"
import { generatePath, Link, Redirect, withRouter } from "react-router-dom"
import KnowmixInfo from "./knowmixInfo/knowmixInfo"
import KnowmixDetails from "./knowmixDetails/knowmixDetails"
import KnowmixSteps from "./knowmixSteps/knowmixSteps"
import Loader from "../../../../components/ui/loader/loader"
import KnowmixError from "../knowmixError/knowmixError"
import ComplaintsModal from "../../../../components/complaints/complaintsModal"
import ErrorOutline from "@material-ui/icons/ErrorOutline"
import { imageAspectRatios } from "../../../../library/constants/images"
import ImagePickerModal from "../../../../components/imagePickerModal/imagePickerModal"

class KnowmixSingle extends Component {
  state = {
    acquired: false,
    logo: null,
    deleted: false,
    blocked: false,
    openAvatarUpdate: false,
    openAddToFolderDialog: false,
    isUploading: false,
    uploadProgress: 0,
    dataReceived: false,
    error404: false,
    redirectToProduct: false,
    complaintsModal: false,
    isReported: false,
  }

  async componentDidMount() {
    const {
      match: { params },
    } = this.props
    try {
      await this.props.getKnowmix({ id: parseInt(params.knowmixId) })
      this.setState({
        logo: this.props.knowmix.currentKnowmix.photo,
        type: this.props.knowmix.currentKnowmix.type,
        redirectToProduct:
          !this.props.knowmix.currentKnowmix.is_owned &&
          !this.props.knowmix.currentKnowmix.is_admin &&
          !this.props.knowmix.currentKnowmix.is_product_admin &&
          !!this.props.knowmix.currentKnowmix.product,
        error404:
          !this.props.knowmix.currentKnowmix.is_admin &&
          !this.props.knowmix.currentKnowmix.is_product_admin &&
          !this.props.knowmix.currentKnowmix.is_owned &&
          !this.props.knowmix.currentKnowmix.is_teacher &&
          !this.props.knowmix.currentKnowmix.product,
        deleted: this.props.knowmix.currentKnowmix.deleted,
        blocked: this.props.knowmix.currentKnowmix.blocked,
        dataReceived: true,
        isReported: !!this.props.knowmix.currentKnowmix.is_reported,
      })
    } catch ({ error }) {
      if (error.code === 23000 || error.code === 20004) {
        this.setState({ error404: true })
      } else {
        this.props.enqueueSnackbar(getErrorText(error.code), {
          variant: "error",
        })
      }
    }
  }

  componentWillUnmount() {
    this.props.clearCurrentKnowmix()
  }

  showComplaintsModal = () => {
    this.setState({ complaintsModal: true })
  }
  hideComplaintsModal = () => {
    this.setState({ complaintsModal: false })
  }

  onUploadProgress = (progressEvent) => {
    let percentCompleted = Math.round(
      (progressEvent.loaded * 100) / progressEvent.total
    )
    this.setState({ uploadProgress: percentCompleted })
  }

  handleClickOpen = (type) => {
    switch (type) {
      case "avatar":
        this.setState({ openAvatarUpdate: true })
        break

      default:
        return
    }
  }

  handleClose = (type) => {
    switch (type) {
      case "avatar":
        this.setState({ openAvatarUpdate: false })
        break

      default:
        return
    }
  }

  startKnowmixFromStep = async (num) => {
    const {
      knowmix: { currentKnowmix },
      match: { params },
    } = this.props
    if (currentKnowmix.type === 1) {
      try {
        await this.props.startKnowmix({ id: currentKnowmix.id })
      } catch ({ error }) {
        return this.props.enqueueSnackbar(getErrorText(error.code), {
          variant: "error",
        })
      }
    }

    this.props.history.push(
      generatePath(routes.KNOWMIX_WALKTHROUGH, {
        knowmixId: params.knowmixId,
        stepId: num,
      })
    )
  }

  startKnowmixGlobal = async () => {
    const {
      knowmix: { currentKnowmix },
      match: { params },
    } = this.props
    if (currentKnowmix.type === 1) {
      try {
        await this.props.startKnowmix({ id: currentKnowmix.id })
        await this.props.getKnowmix({ id: parseInt(params.knowmixId) })
      } catch ({ error }) {
        return this.props.enqueueSnackbar(getErrorText(error.code), {
          variant: "error",
        })
      }
    }

    if (currentKnowmix.steps.length) {
      this.props.history.push(
        {
          pathname: generatePath(routes.KNOWMIX, params),
          search: `?stepId=${currentKnowmix.steps[0].id}`,
        }
        // {  }
      )
    }
  }

  updateImage = async (img) => {
    const {
      knowmix: {
        currentKnowmix: { id },
      },
    } = this.props
    this.setState({ logo: img.cropped_image || logoDefault })
    await this.props.updateKnowmix({ id, full_image: img })
  }

  processLogoUpdate = async (e) => {
    const {
      auth: { userData },
      knowmix: {
        currentKnowmix: { id },
      },
    } = this.props
    const fileData = e.target.files[0]

    this.setState({ isUploading: true })

    try {
      this.setState({ logo: URL.createObjectURL(fileData) })
      const response = await uploadFiles(
        fileData,
        2,
        this.onUploadProgress,
        userData.token
      )
      this.setState({
        logo: response.url,
        isUploading: false,
        uploadProgress: 0,
      })
      await this.props.updateKnowmix({ id, photo: response.url })
    } catch ({ error }) {
      this.setState({ logo: null })
      this.props.enqueueSnackbar(getErrorText(error.code), { variant: "error" })
    }
    document.getElementById("logo-input").value = null
  }

  processLogoDelete = async () => {
    const {
      knowmix: {
        currentKnowmix: { id },
      },
    } = this.props

    try {
      await this.props.updateKnowmix({ id, photo: "" })
      this.setState({
        logo: logoDefault,
        isUploading: false,
        uploadProgress: 0,
      })
    } catch ({ error }) {
      this.props.enqueueSnackbar(getErrorText(error.code), { variant: "error" })
    }
  }

  render() {
    const {
      logo,
      deleted,
      blocked,
      dataReceived,
      error404,
      redirectToProduct,
      openAvatarUpdate,
    } = this.state

    const {
      knowmix: { currentKnowmix },
      match: { params },
    } = this.props

    const hasEditRights = currentKnowmix?.is_admin || currentKnowmix?.is_teacher

    const knowmixLogo = logo || logoDefault

    if (error404) {
      return <NotFound entity="Knowmix" />
    }

    if (dataReceived) {
      if ((deleted || blocked) && hasEditRights) {
        return <KnowmixError knowmix={currentKnowmix} />
      }

      if (redirectToProduct) {
        return (
          <Redirect
            to={generatePath(routes.PRODUCT, {
              productId: currentKnowmix.product.id,
            })}
          />
        )
      }

      return (
        <div className="common-page__content">
          <ComplaintsModal
            open={this.state.complaintsModal}
            knowmix_id={currentKnowmix.id}
            onClose={this.hideComplaintsModal}
            callback={() => this.setState({ isReported: true })}
          />
          <main className="common-page__main">
            <div className="box">
              <div className="box__heading">
                <h1>{currentKnowmix.name}</h1>
              </div>
              <KnowmixDetails knowmix={currentKnowmix} />
            </div>

            <KnowmixSteps
              steps={currentKnowmix.steps}
              startKnowmix={this.startKnowmixFromStep}
              knowmixFinished={currentKnowmix.is_finished}
              canTakeQuiz={!hasEditRights}
            />
          </main>
          <aside className="common-page__sidebar">
            <div className="box">
              <div className="box__content">
                <div className="product-logo">
                  <img
                    src={knowmixLogo}
                    alt="Logo"
                    className="product-logo__img"
                  />
                  {hasEditRights &&
                    !currentKnowmix.deleted &&
                    !currentKnowmix.blocked && (
                      <div
                        className="btn-update-bg"
                        onClick={() => this.handleClickOpen("avatar")}
                      >
                        <CameraAltOutlined />
                        <span className="btn-update-bg__text">Edit photo</span>
                      </div>
                    )}
                </div>
              </div>
            </div>

            <KnowmixInfo knowmix={currentKnowmix} />

            {(hasEditRights ||
              currentKnowmix.is_product_admin ||
              currentKnowmix.is_creator) && (
              <div className="box">
                <div className="box__content">
                  <Link
                    to={generatePath(routes.KNOWMIX_SETTINGS, {
                      knowmixId: params.knowmixId,
                    })}
                    className="link"
                  >
                    <SettingsOutlined className="color-black-38 mr8" /> Manage
                  </Link>
                </div>
              </div>
            )}

            {!hasEditRights &&
              currentKnowmix.type === 1 &&
              !!currentKnowmix.steps.length &&
              currentKnowmix.is_finished && (
                <Button
                  variant="contained"
                  color="primary"
                  onClick={this.startKnowmixGlobal}
                  fullWidth
                >
                  Start course
                </Button>
              )}

            {!hasEditRights &&
              currentKnowmix.is_owned &&
              !!currentKnowmix.teacher && (
                <Button
                  color={"primary"}
                  variant={"outlined"}
                  component={Link}
                  to={{
                    pathname: routes.CONVERSATION,
                    search: `?userId=${currentKnowmix.teacher.id}`,
                  }}
                >
                  Contact teacher
                </Button>
              )}
            {/*{!currentKnowmix.is_owned &&*/}
            {/*  (currentKnowmix.is_admin || currentKnowmix.is_product_admin) &&*/}
            {/*  currentKnowmix.is_finished && (*/}
            {/*    <p className="color-black-54">*/}
            {/*      Add{' '}*/}
            {/*      <Link*/}
            {/*        to={generatePath(routes.PRODUCT, {*/}
            {/*          productId: currentKnowmix.product.id,*/}
            {/*        })}*/}
            {/*        className="link link--inline"*/}
            {/*      >*/}
            {/*        assigned product*/}
            {/*      </Link>{' '}*/}
            {/*      to your product list to start this KnowMix*/}
            {/*    </p>*/}
            {/*  )}*/}
            {/*{currentKnowmix.type !== 1 && !!currentKnowmix.steps.length && (*/}
            {/*    <Button variant="contained" color="primary" onClick={_ => this.startKnowmix(0)} fullWidth>Continue KnowMix</Button>*/}
            {/*)}*/}
            {(!(hasEditRights && currentKnowmix.is_creator) ||
              ((currentKnowmix.type === 2 || currentKnowmix.type === 3) &&
                currentKnowmix.steps.find((s) => s.grade))) && (
              <div className="box">
                <div className="box__content">
                  {(currentKnowmix.type === 2 || currentKnowmix.type === 3) &&
                    currentKnowmix.steps.find((s) => s.grade) && (
                      <Link
                        to={generatePath(routes.KNOWMIX_GRADES, {
                          knowmixId: this.props.match.params.knowmixId,
                        })}
                        className={`link ${
                          !currentKnowmix.is_creator && "mb15"
                        }`}
                      >
                        My grades
                      </Link>
                    )}
                  {!currentKnowmix.is_creator && (
                    <div
                      className={`link ${
                        this.state.isReported ? "link--disabled" : ""
                      }`}
                      onClick={() =>
                        !this.state.isReported && this.showComplaintsModal()
                      }
                    >
                      <ErrorOutline className="color-black-38 mr8" /> Report
                    </div>
                  )}
                </div>
              </div>
            )}

            {openAvatarUpdate && (
              <ImagePickerModal
                // dimensions={{width: 50, x: 20, y: 20}}
                originImage={logo || logoDefault}
                defaultImage={logoDefault}
                open={openAvatarUpdate}
                onSave={this.updateImage}
                onClose={() => this.handleClose("avatar")}
                aspectRatio={imageAspectRatios.square}
              />
            )}

            {/*<Dialog*/}
            {/*    open={openAvatarUpdate}*/}
            {/*    onClose={() => this.handleClose('avatar')}*/}
            {/*    aria-labelledby="alert-dialog-title"*/}
            {/*    aria-describedby="alert-dialog-description"*/}
            {/*>*/}
            {/*    <DialogContent>*/}
            {/*        <div className="f jcc aic full-width image-uploader">*/}
            {/*            <img src={logo || logoDefault} alt="Current logo" className="full-width"/>*/}
            {/*            {isUploading && (*/}
            {/*                <div className="image-uploader__overlay">*/}
            {/*                    <CircularProgress className="image-uploader__indicator" variant="static"*/}
            {/*                                      value={uploadProgress}/>*/}
            {/*                </div>*/}
            {/*            )}*/}
            {/*        </div>*/}
            {/*        <input type="file" id="logo-input" className="hidden"*/}
            {/*               accept="image/gif, image/png, image/jpeg, image/bmp, image/webp"*/}
            {/*               onChange={(e) => this.processLogoUpdate(e)}/>*/}
            {/*    </DialogContent>*/}
            {/*    <DialogActions>*/}
            {/*        <div className="f jcsb full-width">*/}
            {/*            <div>*/}
            {/*                <Button color="primary" onClick={this.handleFileInputOpen}>*/}
            {/*                    Choose photo*/}
            {/*                </Button>*/}
            {/*                {logo !== logoDefault && (*/}
            {/*                    <Button*/}
            {/*                        onClick={this.processLogoDelete}*/}
            {/*                        color="primary"*/}
            {/*                    >*/}
            {/*                        Delete photo*/}
            {/*                    </Button>*/}
            {/*                )}*/}
            {/*            </div>*/}
            {/*            <Button onClick={() => this.handleClose('avatar')} color="primary">*/}
            {/*                Close*/}
            {/*            </Button>*/}
            {/*        </div>*/}
            {/*    </DialogActions>*/}
            {/*</Dialog>*/}
          </aside>
        </div>
      )
    } else {
      return <Loader />
    }
  }
}

const mapStateToProps = ({ auth, knowmix, bookmarks }) => ({
  auth,
  knowmix,
  bookmarks,
})
const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      getKnowmix,
      updateKnowmix,
      clearCurrentKnowmix,
      startKnowmix,
    },
    dispatch
  )

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withSnackbar(withRouter(KnowmixSingle)))
